function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.28 470.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(0 -1 1 0 -144.95 487.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.51,147.39c-7-.45-8.86,11.57-8.86,23.58s4,19.77,5.29,24,1.23,18.28-.84,23.92-10.84,23.39-16.55,33.75,2.3,41.85,6.81,49.86,28.42,15.55,33.68,25,2.87,12.17,7.69,19.2,27.64,31.66,40.22,75.79l10.91-149.77-41.34-44.48Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.38,429.07l-.18.22.84-.35C426.79,429,426.56,429.05,426.38,429.07Zm60.47-74.67c-.77-1.27-1.5-2.5-2.2-3.69h0c-14.28-24.34-16.82-34.78-18.52-41.8a39,39,0,0,0-3.08-9.23l-.83-1.6a55.3,55.3,0,0,1-5.39-13.26c-.86-3.69.35-12.68,1.52-21.37.84-6.27,1.64-12.18,1.56-15.54l0-1.19c-.2-8.8-.62-27.1-2.45-32.23-1.76-4.93-3.53-5.71-6.75-7.11l-1-.46c-1.21-.54-3.25-1.67-5.61-3-5.3-2.93-11.91-6.6-15.3-7.16a29.94,29.94,0,0,0-9.56.17c-4.12-3.34-11.13-7.7-13.26-7.84s-7.46,1.37-8.35,1.62a24.5,24.5,0,0,0-3.82-2.6c-3.05-1.38-8.19-1.2-9.12-1.15-3.51-5.74-7-11.48-8.45-14-2.67-4.5-10-20.87-12.16-25.76-.38-.86-.6-1.37-.62-1.4a.29.29,0,0,0-.13-.14c-.07,0-6.47-2.28-9.15,3.66s.54,19.64,3.95,24.62c1.65,2.41,6.05,12.16,10.51,22.24h0c-.32.29-1.23,1.08-2.48,2.13-3.59,3-10,8.08-13.54,9.23-3.91,1.26-3.56,21.14-3.29,37.12.1,5.88.19,11,0,14-.15,2.85,2.24,6.29,5.9,10l.05,0a176.69,176.69,0,0,0,14.38,12.38c9.19,7.37,18.69,15,19.67,20.35a27.8,27.8,0,0,0,6.94,14.36c4.91,5.06,22.5,81.94,28,106.11,1,4.49,1.63,7.15,1.66,7.23l.49-.1c3.51-4.35,60.42-74.33,60.38-74.34A.25.25,0,0,0,486.85,354.4ZM367.67,218.47c.7-.68,5.42-5.39,6.32-10.07,3.2,7.22,5.18,11.56,5.67,12s.4,2.74.32,4.94a39.77,39.77,0,0,0,0,5.79c-.84.7-6.22,5.33-7.39,9.15l-4.31-5.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,225.56c1.48-6.29-6-12.57-14.72-29.37-.32.29-1.23,1.08-2.48,2.13,1.32,3.57,2.28,7.7.46,9.18-3.46,2.82-4.81,2.91-4.65,6s4.17,24.92,2.48,30,10,6.48,11.82,7.49-.08-7.91,4.36-11.66S381.64,232.57,383.29,225.56Zm-10.66,14.75-4.31-5.37-.65-16.47c.7-.68,5.42-5.39,6.32-10.07,3.2,7.22,5.18,11.56,5.67,12s.4,2.74.32,4.94a39.77,39.77,0,0,0,0,5.79C379.18,231.86,373.8,236.49,372.63,240.31Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.23,421.94c-5.5-24.17-23.09-101.05-28-106.11a27.8,27.8,0,0,1-6.94-14.36c-1-5.36-10.48-13-19.67-20.35a176.69,176.69,0,0,1-14.38-12.38c9,7.51,31.19,23,35.22,23.13,4.18.12,4.53,16.91,11.3,21.31C408.24,317.37,434.44,391.29,424.23,421.94Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.65,350.7c-12.26-3.33-23.26-28.32-23.88-34.42-.73-7.16-.6-12.64-9.11-22.22s-3.42-14.77-3.42-14.77c.68,3.21,6.44,8.24,6.44,8.24-2.32-7.21.33-33.4,1.42-38.29,1-4.3,1.38-30.83-4-39.61-6.29-3.93-5.7,2.73-10.63,2.39-2.67-.19-7.11-3.2-11.24-3.28-3.82-.05-3.85,5.15-14.61.15-5.41-2.52-8,5.19-14.23,2C392,206,385.69,188.26,379.54,183c-2.88-2.49-9.42-13.51-10.69-20.29-1-5.25-7.93-.37-11.22-6-2.7-4.65-1.23-11.35,6.39-9.42,2.18,4.89,9.49,21.26,12.16,25.76,1.49,2.52,4.94,8.26,8.45,14,.93-.05,6.07-.23,9.12,1.15a24.5,24.5,0,0,1,3.82,2.6c.89-.25,6.2-1.78,8.35-1.62s9.14,4.5,13.26,7.84a29.94,29.94,0,0,1,9.56-.17c3.39.56,10,4.23,15.3,7.16,2.36,1.32,4.4,2.45,5.61,3l1,.46c3.22,1.4,5,2.18,6.75,7.11,1.83,5.13,2.25,23.43,2.45,32.23l0,1.19c.08,3.36-.72,9.27-1.56,15.54-1.17,8.69-2.38,17.68-1.52,21.37a55.3,55.3,0,0,0,5.39,13.26l.83,1.6a39,39,0,0,1,3.08,9.23C467.83,315.92,470.37,326.36,484.65,350.7Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.94,207.12a15.23,15.23,0,0,1-7.37-5.49c-2.94-4.18-14.42-23.18-17.6-28.54s-12.79-27.2-12.79-27.2-6.23-2.28-8.84,3.53.35,19.17,3.93,24.39,20.19,45.13,21.56,46.44-1,11.76,1.7,14.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,231.26s-6.66,5.47-7.54,9.57l-4.65-5.8-.67-16.66s6-5.65,6.45-10.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,196.24s-11.07,9.87-16.25,11.54-2.53,39.88-3.1,50.91,37.92,31.37,40,42.74a27.47,27.47,0,0,0,6.89,14.23c5.91,6.09,29.7,113.41,29.7,113.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.5,187.21s5.88-.36,9.15,1.11S410,201.71,413.18,204s8,3.26,8.89,5.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.52,191s6.1-1.82,8.38-1.65,10.81,5.53,14.6,9a33,33,0,0,0,9.94,6.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,197.19a29.44,29.44,0,0,1,9.58-.19c4.88.8,17,8.39,20.85,10.13s5.74,2.1,7.65,7.44,2.28,25.41,2.47,33.34-4.59,30.52-3.07,37,4.46,11.45,6.23,14.92c5.21,10.22.39,15.74,23.81,54.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.58,211.94c4.38,4.93,2.46,13.13,1.47,15.5s.87,12.54,1.18,17.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.94,212.32c8.85,1.27,10.95,7.65,11,11.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.75,208c2.66.13,8.95,5.1,9.45,12.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,218.37s-.86-3.93-2.13-4.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.09,235a49.7,49.7,0,0,0,1.63,6.78c.89,2.4-.7,5.79-.7,5.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,240.83c-.27,3.8,3.39,8.35,4.33,7.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.29,228.18c5.29,2.65.19,30.46-8.4,37.82l-8.09,31.67,8.09,34.64L176,319.7s2-12.34,9.33-16.56,7.35,2.46,7.35,2.46-7.84,19.48-7.35,26.71-13.09,20.62-19.49,30.28-22.34,6.23-38.37,16.64-63,60-63,60L94.57,316.25Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,308.91a46.63,46.63,0,0,0-4,5.84c-.66,1.08-1.28,2.21-1.89,3.37-.28.51-.55,1-.81,1.55l-.1.2c-.3.59-.59,1.18-.89,1.78a2.56,2.56,0,0,1-.11.24c-.26.52-.5,1-.74,1.56s-.56,1.21-.82,1.81l0,0-.71,1.61c-.69,1.56-1.34,3.12-2,4.62s-1.15,2.84-1.68,4.16c-.06.13-.11.26-.16.39-.14.33-.27.66-.39,1-.63,1.59-1.21,3.05-1.74,4.32a1.94,1.94,0,0,1-.13.3c0,.08-.08.17-.13.25a14.2,14.2,0,0,1-4.35,4.36c-.35.25-.71.5-1.09.74-1,.69-2.19,1.37-3.41,2.06l-.93.5c-.75.41-1.51.81-2.3,1.2h0c-9,4.58-20.1,8.7-22.93,11.76-3.75,4.08-4.4,7.41-9,12.21h0a42.19,42.19,0,0,1-4.22,3.85c-5.81,4.71-19.31,29.83-27.64,46-4.15,8.05-7,13.89-7,13.89l-57.47-27s30.17-41.88,31.69-49,5.89-14.37,5.89-14.37-.75-16.06.34-27.34,3.8-30.25,5.08-37.83,8.71-19.44,12.27-28.47,5.61-17.19,8.76-22.74,6.21-15.38,8.06-16.42,3.81.6,5.82,3.47-2.84,19.55-2.84,19.55c3.52-5.8,5.73-17.78,7-20.89s3.72-17.55,3.72-17.55a14.4,14.4,0,0,1,4.21-1.85,6.69,6.69,0,0,1,4,.12c3.62,1.42,5.54,9.36,4.57,18.55s-6.14,28.92-6.14,28.92v0l15-22.78c2.9-4.42,7.9-21.79,8.79-22.91.65-.82,4.71-2.84,7.88-.87a7.25,7.25,0,0,1,2.91,4c2.63,7.67-5,24.91-6,28.29-.85,2.76-7.47,14.14-9.85,18.21l0,0-.76,1.31c.68-1,5.45-7.69,9-8.76,3.84-1.15,11.45-6.08,16.33-9.05s5.1-13.31,11.86-5c2.86,3.52,1.2,9.78-1.31,15.47s-14.52,15.92-14.52,15.92c-.46,1.29-1.59,4.28-3,7.92-.05.15-.11.29-.17.44-.24.66-.5,1.34-.77,2-.35.92-.72,1.87-1.09,2.82-.2.5-.39,1-.58,1.51s-.46,1.17-.69,1.75c-.11.3-.23.59-.34.88,0,.08-.06.17-.1.24-.19.5-.39,1-.58,1.48l-.33.84c-.4,1-.8,2-1.17,2.95a2.52,2.52,0,0,0-.12.29c-.1.23-.2.48-.29.71-.2.49-.39,1-.58,1.41s-.36.87-.52,1.28c-.76,1.8-1.35,3.12-1.65,3.63-1.54,2.6,3.48,29.91,7.48,26.5s14.46-20.32,14.46-20.32c1.47-9.77,7-17.52,14.42-20.74h0a19.33,19.33,0,0,1,1.92-.72c8.43-2.65,9.33,3.84,9.33,3.84C173.77,302.35,180.4,300.41,173.35,308.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,245.66l-14.3,21.85c1.21-8,8.31-25.1,8.31-25.1,1-6.55,9.63-37.11,6.74-41.92a11.75,11.75,0,0,0-3.21-2.42,6.69,6.69,0,0,1,4,.12c3.62,1.42,5.54,9.36,4.57,18.55S109.17,245.66,109.17,245.66Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.57,218.81h0l0,0c.07.09.25.33.51.71a12.14,12.14,0,0,0-.36-1.29Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,267.25s10.3-17.53,14.61-32.75c1.6-5.63,2.37-10.95,1.51-14.93h0a12.14,12.14,0,0,0-.36-1.29l-.18.54A14,14,0,0,0,92.12,216c.8,2.6,1.24,7.38-2.6,13.88C83.51,240.06,82.35,254.22,79,267.25Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,320.69c5.67-4.59,10.27-17.63,16.26-24.26,0,0-.19-11.84,12-21.24h0c-7.45,3.22-12.95,11-14.42,20.74,0,0-10.47,16.91-14.46,20.32s-9-23.9-7.48-26.5c.3-.51.89-1.83,1.65-3.64.17-.4.34-.83.53-1.27s.37-.93.57-1.41c.1-.23.19-.48.29-.71a2.52,2.52,0,0,1,.12-.29c.37-.94.76-1.93,1.17-2.95.11-.28.22-.56.34-.84.18-.49.38-1,.58-1.48,0-.08,0-.16.09-.25.11-.28.23-.57.34-.87.23-.58.45-1.16.69-1.75l.58-1.51c.37-.95.74-1.9,1.09-2.82.26-.69.52-1.37.78-2,.05-.15.11-.3.16-.44-.54,1.05-10.53,20.36-14.32,24.46s-.35,33.08,7.45,30.66C138.6,322.62,140.38,324.1,144.6,320.69Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,320.8c-1.09,11.28-.34,27.34-.34,27.34s-4.38,7.24-5.89,14.37c-.41,1.92-2.9,6.36-6.3,11.82.87-1.17,10.18-13.7,11.44-18.62,1.32-5.17,3.18-6.18,7.79-11.7s8.79-3.61,8.79-3.61-2.68,16.21,4.14,7,10.93-21.08,12.55-65.65c0,0-3,4.83-6,20.75s-8.09,19.61-8.09,19.61A150.89,150.89,0,0,1,68,287.51s-3.75,18.53-4.9,27.13-1.42-10.72-2-22.78c-.56-11.31.41-15.28,3.76-22.3-2.41,4.93-4.51,9.68-5.15,13.41C58.38,290.55,55.67,309.52,54.58,320.8Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,374.74a42.19,42.19,0,0,1-4.22,3.85c-5.81,4.71-19.31,29.83-27.64,46,1.67-7.09,4.67-17.07,9.71-25.94C99.87,382.78,108.77,378.6,113,374.74Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,231.42c-.85,2.76-7.47,14.14-9.85,18.21l0,0c-3,3.48-11.21,20.54-13.22,23s-5.86,2.67-4.15-1.11c2.79-6.17,11.25-27.3,15.62-31.4s11.09-21.44,14.49-31.19c1.71-4.93,1.19-8,.24-9.93a7.25,7.25,0,0,1,2.91,4C146.37,210.8,138.78,228,137.73,231.42Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43,233.16c-4.86,3-12.44,7.87-16.29,9,.52-.1,7.37-1.37,9.84,2.83,2.56,4.39,2.48,14.55,2.48,14.55s12-10.23,14.52-15.92,4.17-11.95,1.31-15.48C157.53,219.85,157.32,230.2,152.43,233.16Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.13,438.51s26-52.87,34.66-59.92,8.55-11,13.23-16.06,31.92-13,35.28-21.18,9-23.92,16.06-32.43.41-6.57,10.75-30.61c0,0-.92-6.49-9.34-3.84S160,285.34,158.43,295.94c0,0-10.47,16.9-14.47,20.31s-9-23.9-7.47-26.5,10.41-25.9,12-30.17c0,0,12-10.24,14.51-15.92s4.18-12,1.32-15.48c-6.76-8.33-7,2-11.86,5s-12.48,7.9-16.33,9.05S127,251.1,127,251.1s9.68-16.3,10.73-19.68,8.63-20.62,6-28.29-9.89-4.3-10.78-3.18-5.89,18.48-8.8,22.9l-15,22.81s5.17-19.71,6.14-28.91-1-17.14-4.57-18.57-8.23,1.74-8.23,1.74-2.41,14.43-3.73,17.54-3.53,15.1-7,20.9c0,0,4.85-16.69,2.84-19.56s-4-4.5-5.81-3.46-4.93,10.86-8.07,16.42-5.21,13.71-8.76,22.74S61,275.38,59.67,283s-4,26.56-5.09,37.84-.34,27.34-.34,27.34-4.38,7.24-5.89,14.37-31.69,49-31.69,49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,245.66c-2.9,3.64-12.07,19.87-14.3,21.85a8.52,8.52,0,0,1-4.18,2.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,238.36S91.11,242,86,252.89s-7.38,15.44-9.16,17.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,251.1c-4.28,6.28-8.68,17-10.94,19.93s-3.65,3.32-3.65,3.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,266.69a10.88,10.88,0,0,0-4.4,3.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,316.25s-3.84,8.84-9.4,6.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,289.75s-4.53,10.53-3.36,15.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39,277.08s-4.53,1.29-3.87,9-2.61,37-2.61,37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.48,279.74c-3.36,5.84-3.55,6-3.06,14.42s-.49,28.54-.49,28.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.24,348.14s3.95-4.42,3-9.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,378.59s-8.9,7.22-14.48,16.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg8);
export default __webpack_public_path__ + "static/media/img8.149d2dd9a8fddfa6d91874fa44af375c.svg";
export { ForwardRef as ReactComponent };